var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcesimg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 474",
    d: "M13.1263 1H15.9516C16.5589 1 17.1373 1.263 17.5408 1.72267L20.4629 5.05149C21.141 5.82402 21.1814 6.9755 20.559 7.79476L12.6854 18.1597C11.8342 19.2801 10.1658 19.2801 9.31463 18.1597L1.44095 7.79476C0.818605 6.9755 0.85896 5.82402 1.53709 5.05149L4.45918 1.72267C4.86269 1.263 5.44106 1 6.04842 1H9.10994M13.1263 1L15.2526 6.38285M13.1263 1H9.10994M15.2526 6.38285H20.5684M15.2526 6.38285L11 18.7634L6.74736 6.38285M15.2526 6.38285H6.74736M9.10994 1L6.74736 6.38285M1.43156 6.38285H6.74736",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcesimg8);
export default __webpack_public_path__ + "static/media/procesimg8.380410ecce1e8f1bb108e551d2a983ce.svg";
export { ForwardRef as ReactComponent };